import {Component, inject} from '@angular/core';
import {MatDialogActions, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';

@Component({
  selector: 'oct-brief-modal',
  templateUrl: './brief-modal.component.html',
  styleUrls: ['./brief-modal.component.scss'],
  imports: [MatDialogContent, MatDialogActions, MatButton]
})
export class BriefModalComponent {
  dialogRef = inject<MatDialogRef<BriefModalComponent>>(MatDialogRef);

  confirm() {
    this.dialogRef.close({event: true});
  }

  closeDialog() {
    this.dialogRef.close({event: false});
  }
}
